import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SubNavService } from 'projects/go-style-guide/src/app/shared/components/sub-nav/sub-nav.service';

@Component({
  selector: 'app-input-group-docs',
  templateUrl: './input-group-docs.component.html'
})
export class InputGroupDocsComponent implements OnInit {

  linkToSource: string = 'https://github.com/mobi/goponents/tree/dev/projects/go-lib/src/lib/components/go-input-group';

  // Controls for examples
  usernameControl: FormControl = new FormControl('');
  priceControl: FormControl = new FormControl('');
  websiteControl: FormControl = new FormControl('');
  searchControl: FormControl = new FormControl('');
  emailControl: FormControl = new FormControl('');

  basicExample: string = `
  <go-input-group label="Username">
    <span goInputGroupPrepend>@</span>
    <go-input [control]="usernameControl"></go-input>
  </go-input-group>
  `;

  appendExample: string = `
  <go-input-group label="Amount">
    <go-input [control]="priceControl"></go-input>
    <span goInputGroupAppend>.00</span>
  </go-input-group>
  `;

  bothExample: string = `
  <go-input-group label="Website">
    <span goInputGroupPrepend>https://</span>
    <go-input [control]="websiteControl"></go-input>
    <span goInputGroupAppend>.com</span>
  </go-input-group>
  `;

  buttonExample: string = `
  <!-- Append button (button is a direct child of go-input-group) -->
  <go-input-group>
    <go-input [control]="searchControl" placeholder="Search..."></go-input>
    <go-button goInputGroupAppend buttonVariant="primary">Go</go-button>
  </go-input-group>

  <!-- Prepend button -->
  <go-input-group label="Email">
    <go-button goInputGroupPrepend buttonVariant="secondary">Search</go-button>
    <go-input [control]="emailControl"></go-input>
  </go-input-group>
  `;

  sizeExample: string = `
  <go-input-group size="small" label="Small">
    <span goInputGroupPrepend>$</span>
    <go-input [control]="priceControl"></go-input>
  </go-input-group>

  <go-input-group size="default" label="Default">
    <span goInputGroupPrepend>$</span>
    <go-input [control]="priceControl"></go-input>
  </go-input-group>

  <go-input-group size="large" label="Large">
    <span goInputGroupPrepend>$</span>
    <go-input [control]="priceControl"></go-input>
  </go-input-group>
  `;

  constructor(private subNavService: SubNavService) {
    this.subNavService.pageTitle = 'Input Group';
    this.subNavService.linkToSource = this.linkToSource;
  }

  ngOnInit(): void {}
}
